<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="min-width: 500px">
      <q-card-section>
        <div class="row items-center">
          <div class="col">
            <div class="text-h6">{{ editMode ? 'Edit Section' : 'Add Section' }}</div>
            <div v-if="editMode" class="text-caption text-grey-6 q-mt-xs">
              <q-icon name="info_outline" size="14px" class="q-mr-xs" />
              Changes are saved automatically
            </div>
          </div>
          <div class="col-auto">
            <q-btn v-close-popup flat round icon="close" />
          </div>
        </div>
      </q-card-section>

      <q-card-section>
        <q-input
          :model-value="localSection.section_name"
          label="Section Name *"
          :rules="[val => !!val || 'Section name is required']"
          outlined
          dense
          @update:model-value="updateField('section_name', $event)"
          @blur="editMode ? emitFieldChange('section_name') : null"
        />

        <q-input
          :model-value="localSection.section_description"
          label="Description"
          type="textarea"
          outlined
          dense
          class="q-mt-md"
          @update:model-value="updateField('section_description', $event)"
          @blur="editMode ? emitFieldChange('section_description') : null"
        />

        <div class="row q-mt-md q-gutter-md">
          <div class="col">
            <q-input
              :model-value="localSection.display_order"
              label="Display Order"
              type="number"
              min="1"
              outlined
              dense
              @update:model-value="updateField('display_order', $event)"
              @blur="editMode ? emitFieldChange('display_order') : null"
            />
          </div>
          <div class="col flex items-center">
            <q-toggle
              :model-value="localSection.is_visible"
              label="Visible in Tender"
              @update:model-value="updateFieldAndEmit('is_visible', $event)"
            />
          </div>
        </div>

        <div v-if="!editMode" class="q-mt-lg">
          <q-btn
            unelevated
            label="Create Section"
            color="primary"
            :loading="saving"
            :disable="saving || !localSection.section_name"
            class="full-width"
            @click="handleSave"
          />
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { ref, watch } from 'vue';

  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    section: {
      type: Object,
      default: () => ({}),
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:section',
    'save',
    'field-changed',
  ]);

  // Local copy of section for editing
  const localSection = ref({ ...props.section });

  // Watch for external changes to section prop
  watch(() => props.section, (newSection) => {
    localSection.value = { ...newSection };
  }, { deep: true });

  // Methods
  function updateField(field, value) {
    localSection.value[field] = value;
    emit('update:section', localSection.value);
  }

  function updateFieldAndEmit(field, value) {
    updateField(field, value);
    if (props.editMode) {
      emitFieldChange(field);
    }
  }

  function emitFieldChange(field) {
    emit('field-changed', {
      field,
      value: localSection.value[field],
    });
  }

  function handleSave() {
    emit('save', localSection.value);
  }
</script>

<style scoped>
/* Component-specific styles */
</style>
